export default __webpack_public_path__ + "static/media/promocionAlarma5Mobile.de4e02fb.png";